import {MI} from "../init";

/**
 * @constructor
 * @returns {Arrow}
 */
export function Arrow() {

	this._hitSpeed = 40;
	this._hitAngle = 5;

	/** @type {MadnesObject} */
	this._arrow;
	/** @type {MadnesObject} */
	this._fire;
	/** @type {MadnesObject} */
	this._fire2;

	this._toX = 0;
	this._toY = 0;

	/** @type {MadnesTween} */
	this._tweenFadeIn;
	/** @type {MadnesTween} */
	this._tweenMove;

	this._delayTime = 0;
	this._flyTime = 0;

	/** @type {?Function} */
	this._onStart;

	/** @type {?Function} */
	this._onHit;

	this._reelX = -1;
}

/**
 * @param {number} reelX
 * @param {MadnesGroup=} group
 */
Arrow.prototype.create = function(reelX, group) {

	this._reelX = reelX;

	this._delayTime = (reelX + 1) * 90;
	this._flyTime = 200 + reelX * 100;

	//var point = MI.getCircleRandInnerPoint(-100 , MI.getHe() + 100, 60);

	this._arrow = MI.addImg(-100, MI.getHe() + 100, "arrow_atlas").setFrameName("arrow_00000");
	this._arrow.setAnchor(0.779, 0.379);
	group && group.add(this._arrow);

	this._fire = MI.addImg(0, 0, "arrow_atlas").setFrameName("fire_00000");
	this._fire.setAnchor(0.5, 0.5);
//	this._fire.createAnims();
//	this._fire.anims.add("fire", MI.generateFrameNames("fire_", 0, 9, "", 5));
	this._fire.setVisible(false);
	this._arrow.addChild(this._fire);

	this._fire2 = MI.addImg(0, 0, "arrow_atlas").setFrameName("fire_00000");
	this._fire2.setAnchor(0.5, 0.5);
	this._fire2.createAnims();
	this._fire2.anims.add("fire", MI.generateFrameNames("fire_", 0, 9, "", 5));
	this._fire2.setVisible(false);
	this._fire2.kill();

	group && group.add(this._fire2);

	this._arrow.setVisible(false);
};

/**
 * @param {number} x
 * @param {number} y
 */
Arrow.prototype.setScale = function(x, y) {
	this._arrow.setScale(x, y);
	this._fire2.setScale(x, y);
};

/**
 * @param {MadnesObject} symbol
 */
Arrow.prototype.setToSymbol = function(symbol) {

	var scaleX = this._arrow.getScaleX();
	var point = MI.getCircleRandInnerPoint(30, -68, 10);

	this._toX = symbol.getPosX() + point['x'] * scaleX;
	this._toY = symbol.getPosY() + point['y'] * scaleX;
};

/**
 * @param {MadnesObject} symbol
 */
Arrow.prototype.setSymbolDistance = function(symbol) {

	var x = symbol.getPosX();
	var y = symbol.getPosY();

	var point = MI.getCircleRandInnerPoint(-MI.getWi() - 60, MI.getHe() + 60, 60);
	this._arrow.setPos(x + point['x'], y + point['y'], true);
};

/**
 * @param {number} x
 * @param {number} y
 */
Arrow.prototype.setFrom = function(x, y) {
	this._arrow.setPos(x, y, true);
};

/**
 * @returns {Promise}
 */
Arrow.prototype.play = function() {

	var _self = this;
	this._onStart && MI.createTimer().add(this._onStart, this._delayTime);

	return new Promise(function(res) {
		_self._arrow.setVisible(true);
		_self._fire.setVisible(true);
		//_self._fire.anims.loop("fire");

		_self._tweenMove = MI.addTween().to(_self._arrow, { 'x': _self._toX, 'y': _self._toY }, {
			'duration': _self._flyTime,
			'callback': function() {
				_self._hit();
				MI.createTimer().add(res, 800);
			}
		});
	});
};

Arrow.prototype._hit = function() {

	this._onHit && this._onHit();

//	this._fire.anims.stop();
	this._fire.destroy();
	this._fire = null;

	this._fire2.anims.loop("fire");
	this._fire2.setPos(this._toX, this._toY);
	this._fire2.revive();

	this._tweenMove = MI.addTween().to(this._arrow, { 'angle': this._hitAngle }, {
		'duration': this._hitSpeed,
		'yoyo': true,
		'count': 1
	});

};

/** @param {Function} func */
Arrow.prototype.setOnStart = function(func) {
	this._onStart = func;
};

/** @param {Function} func */
Arrow.prototype.setOnHit = function(func) {
	this._onHit = func;
};

//Arrow.prototype.calcDelayTime = function(reelX) {
//	return (reelX + 1) * 90;
//};
//
//Arrow.prototype.calcFlyTime = function(reelX) {
//	return 200 + reelX * 100;
//};

Arrow.prototype.fadeIn = function() {
	this._arrow.setAlpha(0);
	this._tweenFadeIn = MI.addTween().to(this._arrow, { 'alpha': 1 }, {
		'duration': this._flyTime * 0.9
	});
};

/**
 * @param {number} duration
 */
Arrow.prototype.fadeOut = function(duration) {

	if(typeof duration === 'undefined') { duration = 100; }

	MI.addTween().to(this._arrow, { 'alpha': 0 }, {
		'duration': duration
	});

	MI.addTween().to(this._fire2, { 'alpha': 0 }, {
		'duration': duration
	});
};

Arrow.prototype.destroy = function() {

	this._tweenMove && this._tweenMove.stop();
	this._tweenMove = null;

	this._tweenFadeIn && this._tweenFadeIn.stop();
	this._tweenFadeIn = null;

//	this._fire && this._fire.anims.stop();

	this._fire2.anims.stop();
	this._fire2.destroy();
	this._fire2 = null;

	this._arrow.destroy();
};